<template>
  <div class="e-accordions__accordion">
    <div class="e-accordions__accordion--plain">
      <button
        @click="toggleOpen()"
        class="e-accordions__accordion-button"
        v-bind:class="{ isOpen : open }"
        :aria-expanded="open"
        aria-label="Open section"
        :aria-controls="id"
      >

        <div class="e-accordions__accordion-title">{{ title }}</div>

        <span class="e-accordions__chevron">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M24 13.3333L16.9428 20.3904C16.4221 20.9111 15.5779 20.9111 15.0572 20.3904L8 13.3333" stroke="#262E40" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </span>
      </button>
      <div
        :id="id"
        class="e-accordions__accordion-wrapper"
        :class="{ 'e-accordions__accordion-wrapper--open' : open }"
        :aria-hidden="!open"
      >
        <div class="e-accordions__accordion-content-wrapper u-content">
          <div class="e-accordions__accordion-expanded-content" v-html="expandedContent"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    title: String,
    expandedContent: String,
  },
  data() {
    return {
      id: null,
      open: false,
    };
  },
  mounted() {
    this.id = this._uid;
  },
  methods: {
    toggleOpen: function () {
      this.open = !this.open;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
